// Proper scroll behavior for Gatsby
// - New pages: scroll to top
// - Back/forward navigation: restore scroll position
// - Hash links: let browser handle anchor navigation
export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition
}) => {
  // Get saved scroll position for back/forward navigation
  const currentPosition = getSavedScrollPosition(location)

  // If navigating back/forward and there's a saved position, use it
  if (currentPosition) {
    return currentPosition
  }

  // For hash/anchor links, let browser handle it
  if (location.hash) {
    return false
  }

  // For all other navigation (clicking links), scroll to top
  return [0, 0]
}